import React from 'react';
import Loader from '@v7/form/src/components/Loader';
import { DeleteIcon } from '@v7/form/src/images/DeleteIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { UPLOAD_STATUS } from './constant';
import { FileUploadActionsProps } from './types';

const FileUploadActions: React.FC<FileUploadActionsProps> = ({ uploadStatus, onClearFile }) => {
  const getFileTrailingIcon = () => {
    switch (uploadStatus) {
      case UPLOAD_STATUS.UPLOADING:
        return <Loader />;
      case UPLOAD_STATUS.SUCCESS:
        return <DeleteIcon />;
      case UPLOAD_STATUS.FAILED:
        return <FontAwesomeIcon icon={faCircleExclamation as IconProp} className="text-red-400" />;
      default:
        return null;
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClearFile}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClearFile(e);
        }
      }}
    >
      {getFileTrailingIcon()}
    </div>
  );
};

export default FileUploadActions;
